export default __webpack_public_path__ + "static/media/sideBar-bg.c0ffd542.webp";